import { parseDateTime } from '@Utils/transformDateTime';
import { TenderGetResponse } from '@Types/api/form/tenderRequest/TenderGetResponse';
import { MaterialDto } from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';

interface FieldSourceProps {
  data: TenderGetResponse;
}

interface FieldMaterialSourceProps {
  data: MaterialDto;
}

const tenderFieldSource = ({
  data,
}: FieldSourceProps): Array<{
  label: string;
  value: string | number | boolean;
}> => {
  const {
    id,
    status,
    materialGroup,
    classification,
    createdOn,
    tenderExpiryDate,
    tenderForDesc,
    prForDesc,
    tenderExtension,
    tenderModeDesc,
    priority,
    sentCount,
    replyCount,
    tenderSentDate,
    delayDays,
    tenderAmount,
    approver,
  } = data;

  const source = {
    'Tender No.': id,
    Status: status,
    'Material Group': materialGroup,
    Classification: classification,
    'Sent On': parseDateTime(tenderSentDate),
    'Expiry On': parseDateTime(tenderExpiryDate),
    'Tender For': tenderForDesc,
    'PR For': prForDesc,
    'Tender Extension': tenderExtension,
    'Tender Mode': tenderModeDesc,
    Priority: priority,
    'Sent Count': sentCount,
    'Reply Count': replyCount,
    'Approver Received On': parseDateTime(createdOn),
    'Delay Days': delayDays,
    'Tender Amount': tenderAmount,
    Approver: approver,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export const tenderInfoFieldSource = ({
  data,
}: FieldSourceProps): Array<{
  label: string;
  value: string | number | boolean;
}> => {
  const { id, materialGroup, tenderForDesc, prForDesc, tenderExtension } = data;

  const source = {
    'Tender No.': id,
    'RFQ Type': prForDesc,
    'Tender For': tenderForDesc,
    'Tender Extension': tenderExtension,
    'Material Group': materialGroup,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export const materialInfoFieldSource = ({
  data,
}: FieldMaterialSourceProps): Array<{
  label: string;
  value: string | number | boolean;
}> => {
  const { requiredQty, code, description, matId, unit } = data;

  const source = {
    'Material No.': matId || '',
    'Material Code': code || '',
    'Material Description': description || '',
    Unit: unit || '',
    'Required Quantity': requiredQty || '',
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default tenderFieldSource;
